import { ConfigFieldEntry } from "@/destinations/types";

function matchesCondition(
  values: Record<string, unknown>,
  condition: { field: string; value: string | string[] },
): boolean {
  const current = values[condition.field];
  return Array.isArray(condition.value)
    ? condition.value.includes(current as string)
    : current === condition.value;
}

export function isFieldVisible(
  field: ConfigFieldEntry,
  values: Record<string, unknown>,
): boolean {
  if (field.enabledIfCheckbox) {
    return !!values[field.enabledIfCheckbox];
  }
  if (field.visibleWhen) {
    return matchesCondition(values, field.visibleWhen);
  }
  return true;
}

function isEmpty(value: unknown): boolean {
  if (typeof value === "string") {
    return value.trim() === "";
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return value === undefined || value === null;
}

/**
 * Names of visible required fields that have no value yet. The backend never
 * returns sensitive values, so a sensitive field listed in `savedSecretKeys`
 * already has one.
 */
export function getMissingRequiredFields(
  fields: ConfigFieldEntry[],
  values: Record<string, unknown>,
  savedSecretKeys: ReadonlySet<string> = new Set(),
): string[] {
  return fields
    .filter((field) => isFieldVisible(field, values))
    .filter(
      (field) =>
        field.type !== "boolean" &&
        (field.required ||
          (!!field.requiredWhen &&
            matchesCondition(values, field.requiredWhen))),
    )
    .filter((field) => !(field.sensitive && savedSecretKeys.has(field.key)))
    .filter((field) => isEmpty(values[field.key]))
    .map((field) => field.name);
}
